// 識別結果から日本語の解説テキストを生成する
// 入力: identifyの結果（identifiedかvisualDescription）
// 出力: { narration: '...', sourceMode: 'identified' | 'visual' }

const API_BASE = import.meta.env.VITE_API_BASE || '';

export async function narrate(payload) {
  const res = await fetch(`${API_BASE}/api/narrate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const message = await safeErrorMessage(res);
    throw new Error(message);
  }
  return await res.json();
}

async function safeErrorMessage(res) {
  try {
    const data = await res.json();
    return data?.error || `解説の生成に失敗しました (${res.status})`;
  } catch {
    return `解説の生成に失敗しました (${res.status})`;
  }
}
